import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { MatDialogModule, MatSnackBarModule, MatInputModule, MatFormFieldModule, MatChipsModule, MatTableModule, MatExpansionModule, MatProgressBarModule, MatButtonModule, MatSlideToggleModule, MatButtonToggleModule, MatSliderModule, MatAutocompleteModule, MatSelectModule, MatMenuModule, } from '@angular/material';
import { NumberInputModule } from './components/number-input/number-input.module';
import { VideoPlayerModule } from './components/video-player/video-player.module';
import { CheckboxModule } from './components/checkbox/checkbox.module';
// Components
import { BoxComponent } from './components/box/box.component';
import { IntrotextComponent } from './components/introtext/introtext.component';
import { VideoDialogComponent } from './components/videoDialog/videoDialog.component';
import { RankingAchievementComponent } from './components/ranking-achievements/ranking-achievement.component';
import { MpDialogComponent } from './components/mp-dialog/mp-dialog.component';
import { ActivityAchievementComponent } from './components/activity-achievement/activity-achievement.component';
import { PointsOverviewComponent } from './components/points-overview/points-overview.component';
import { ModuleComponent } from './components/module/module.component';
import { RemindOverviewComponent } from './components/remind-overview/remind-overview.component';
import { ExpansionPanelComponent } from './components/expansion-panel/expansion-panel.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { AddDialogComponent } from './components/add-dialog/add-dialog.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { CategorySelectionDialogComponent } from './components/category-selection-dialog/category-selection-dialog.component';
import { ClickOutsideModule } from 'ng-click-outside';
import { ReminderBoxComponent } from './components/reminder-box/reminder-box.component';
import { TimeInputComponent } from './components/time-input/time-input.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { InputComponent } from './components/input/input.component';
import { DateRangePickerModule } from './components/date-range-picker/date-range-picker.module';
import { ChipsModule } from './components/chips/chips.module';
import { InfoPopupComponent } from './components/info-popup/info-popup.component';
import { ChallengeStatisticsComponent } from './components/challenge-statistics/challenge-statistics.component';
import { ButtonComponent } from './components/button/button.component';
import { NextChallengeComponent } from './components/challenge-statistics/components/next-challenge/next-challenge.component';
import { NextChallengeUserComponent } from './components/challenge-statistics/components/next-challenge-user/next-challenge-user.component';
import { UserNotificationComponent } from './components/user-notification/user-notification.component';
import { ChallengeLeaderboardComponent } from './components/challenge-statistics/components/challenge-leaderboard/challenge-leaderboard.component';
import { ChallengeExpansionPanelComponent } from './components/challenge-expansion-panel/challenge-expansion-panel.component';
import { ChallengeLeaderboardBonusComponent } from './components/challenge-statistics/components/challenge-leaderboard/components/challenge-leaderboard-bonus/challenge-leaderboard-bonus.component';
import { AchievementComponent } from './components/achievement/achievement.component';
import { AchivementProgressComponent } from './components/achievement/components/progressBar/progress-bar.component';
import { DailyRoundProgressBarComponent } from './components/activity-achievement/components/daily-round-progress-bar.component';
import { CalendarActivityComponent } from './components/activity-achievement/components/calender-activity.component';
import { DailyProgressBarComponent } from './components/activity-achievement/components/calender-progress-bar.component';
import { ActivityComponent } from './components/activity/activity.component';
import { RankingComponent } from './components/ranking/ranking.component';
import { SuccessDialogComponent } from './components/achievement/components/success-dialog/success-dialog.component';
import { HelpDialogComponent } from './components/achievement/components/help-dialog/help-dialog.component';
var B2A_DIRECTIVES = [
    MpDialogComponent,
    VideoDialogComponent,
    AddDialogComponent,
    SuccessDialogComponent,
    HelpDialogComponent,
    CategorySelectionDialogComponent,
    SnackbarComponent,
];
var B2A_COMPONENTS = [
    BoxComponent,
    IntrotextComponent,
    VideoDialogComponent,
    ChallengeStatisticsComponent,
    NextChallengeComponent,
    NextChallengeUserComponent,
    ChallengeLeaderboardComponent,
    ChallengeLeaderboardBonusComponent,
    RankingAchievementComponent,
    RankingComponent,
    AchievementComponent,
    AchivementProgressComponent,
    DailyRoundProgressBarComponent,
    CalendarActivityComponent,
    DailyProgressBarComponent,
    ActivityAchievementComponent,
    ActivityComponent,
    PointsOverviewComponent,
    ModuleComponent,
    RemindOverviewComponent,
    ExpansionPanelComponent,
    ToggleComponent,
    SnackbarComponent,
    CategorySelectionDialogComponent,
    ReminderBoxComponent,
    TimeInputComponent,
    InputComponent,
    InfoPopupComponent,
    ButtonComponent,
    UserNotificationComponent,
    ChallengeExpansionPanelComponent,
];
var B2A_MODULES = [
    MatButtonModule,
    MatProgressBarModule,
    MatDialogModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatTableModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatExpansionModule,
    MatSelectModule,
    VideoPlayerModule,
    ChartsModule,
    NumberInputModule,
    CheckboxModule,
    ClickOutsideModule,
    MatAutocompleteModule,
    NgxChartsModule,
    MatMenuModule,
    DateRangePickerModule,
    ChipsModule,
    FormsModule,
    ReactiveFormsModule,
];
var ThemeModule = (function () {
    function ThemeModule() {
    }
    return ThemeModule;
}());
export { ThemeModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/theme.module.ts.pre-build-optimizer.js